module.exports = __webpack_public_path__ + "static/img/services-4.d97fab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/services-4.png
// module id = XGiR
// module chunks = 1